import { ajax_get } from '../network/Ajax';

function setPredefined(callback) {

    ajax_get("/api/v1/predefined", callback, null, null, true);
}

export { setPredefined };
